import React, {useEffect, useState} from 'react'
import { useIntl } from 'react-intl'
import DatePickerInput from '../../../../../components/form/DatePickerInput'
import { MODIFY_SOCIAL_SECURITY_FIELDS } from '../../services/personalInfoConstants'
import CheckboxInput from '../../../../../components/form/CheckboxInput'
import InfoField from '../../../../../components/InfoField'
import { Box } from '@mui/material'
import {useForm} from "react-final-form"

type EndTeletransmissionProps = {
	allBeneficiaries: any[]
	errors: any
	changeDate: (date: Date | null) => void
}

const EndTeletransmission: React.FC<EndTeletransmissionProps> = ({ allBeneficiaries, errors, changeDate }) => {
	const intl = useIntl()
	const form = useForm()
	const [initialValue, setInitialValue] = useState<Date>(new Date())
	const beneficiaires = form.getFieldState(MODIFY_SOCIAL_SECURITY_FIELDS.BENEFICIARIES)?.value

	const BENEFICIARIES_DATA: SelectOption[] = allBeneficiaries ? allBeneficiaries.map((beneficiary: any) => {
		return {
			value: beneficiary[0],
			label: `${beneficiary[1].prenom} ${beneficiary[1].nom}`
		}
	}) : []

	// Conditions sur la date d'effet par défaut
	useEffect(() => {
		const today = new Date()

		if (!beneficiaires || beneficiaires.length === 0) {
			setInitialValue(today)
			changeDate(null)
		} else {
			// Date par défaut = date d'effet de garantie la plus grande si > today
			const datesEffetFuture = beneficiaires.flatMap((b: any) =>
				allBeneficiaries
					.filter((beneficiary: any) => beneficiary[0] === b)
					.flatMap((beneficiary: any) => beneficiary[1].garanties)
					.filter((garantie: any) => garantie.base && new Date(garantie.dateDebut) > today)
					.map((garantie: any) => new Date(garantie.dateDebut))
			).sort((a: { getTime: () => number }, b: { getTime: () => number }) => b.getTime() - a.getTime())

			if (datesEffetFuture.length > 0) {
				setInitialValue(datesEffetFuture[0])
				changeDate(datesEffetFuture[0])
			} else {
				setInitialValue(today)
				changeDate(null)
			}
		}
	}, [beneficiaires])

	return (
		<>
			<InfoField
				label={intl.formatMessage({ id: 'personalInfo.personalData.modifySS.form.beneficiaries.title' })}
				value={
					<CheckboxInput
						name={MODIFY_SOCIAL_SECURITY_FIELDS.BENEFICIARIES}
						data={BENEFICIARIES_DATA}
						error={errors[MODIFY_SOCIAL_SECURITY_FIELDS.BENEFICIARIES]}
					/>
				}
				direction="column"
				required
			/>
			<Box display="flex" flex={1}>
				<DatePickerInput
					name={MODIFY_SOCIAL_SECURITY_FIELDS.DATE_OF_ENTRY}
					label={intl.formatMessage({ id: 'personalInfo.personalData.modifySS.form.startDate.title' })}
					initialValue={initialValue.toLocaleDateString('fr-FR')}
					minDate={initialValue}
					disablePast
				/>
			</Box>
		</>
	)
}

export default EndTeletransmission
